import { AxiosRequestConfig } from 'axios';

const endpoint = '/api/runner';

export default {
    all: (fetchProviderRunners: boolean = false) =>
        ({
            method: 'GET',
            url: `${endpoint}`,
            params: { ['fetch-providers']: fetchProviderRunners },
        } as AxiosRequestConfig),
    generateToken: (data: any) => ({ method: 'POST', url: `${endpoint}`, data } as AxiosRequestConfig),
    getLatestBinaries: () => ({ method: 'GET', url: `${endpoint}/binaries` } as AxiosRequestConfig),
    pingRunners: () => ({ method: 'POST', url: `${endpoint}/ping` } as AxiosRequestConfig),
    delete: (id: string) => ({ method: 'DELETE', url: `${endpoint}/${id}` } as AxiosRequestConfig),
    retrieve: (id: string) => ({ method: 'GET', url: `${endpoint}/${id}` } as AxiosRequestConfig),
    configure: (id: string, data: any) =>
        ({ method: 'PATCH', url: `${endpoint}/${id}/configure`, data } as AxiosRequestConfig),
};
